import React, { useState } from 'react';
import { Logo } from './Brand.jsx';
import { azureEnabled } from '../lib/msal.js';

export function LoginScreen({ error, onLogin, onAzureLogin }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const [localError, setLocalError] = useState(error);

  async function submit(event) {
    event.preventDefault();
    setBusy(true);
    setLocalError('');
    try {
      await onLogin(email, password);
    } catch (err) {
      setLocalError(err.message);
    } finally {
      setBusy(false);
    }
  }

  async function loginWithAzure() {
    setBusy(true);
    setLocalError('');
    try {
      // loginRedirect navigates the browser away — setBusy(false) is never
      // reached on success; it only runs if the redirect itself throws.
      await onAzureLogin();
    } catch (err) {
      setLocalError(err.message || 'Microsoft sign-in failed');
      setBusy(false);
    }
  }

  return (
    <main className="login-page">
      <form className="login-panel" onSubmit={submit}>
        <Logo height={40} />
        <h1>Born Digital Time Tracking</h1>
        <p>Internal planning, budget burn, and time reporting.</p>

        {azureEnabled && (
          <>
            <button
              type="button"
              className="azure-sso-btn"
              onClick={loginWithAzure}
              disabled={busy}
            >
              <MicrosoftLogo />
              Sign in with Microsoft
            </button>
            <div className="login-divider">
              <span>or</span>
            </div>
          </>
        )}

        <label>
          Email
          <input
            value={email}
            onChange={(event) => setEmail(event.target.value)}
          />
        </label>
        <label>
          Password
          <input
            type="password"
            value={password}
            onChange={(event) => setPassword(event.target.value)}
          />
        </label>
        {localError && <div className="error">{localError}</div>}
        <button className="primary" disabled={busy}>
          {busy ? 'Signing in...' : 'Sign in'}
        </button>
      </form>
    </main>
  );
}

function MicrosoftLogo() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="1" y="1" width="9" height="9" fill="#f25022" />
      <rect x="11" y="1" width="9" height="9" fill="#7fba00" />
      <rect x="1" y="11" width="9" height="9" fill="#00a4ef" />
      <rect x="11" y="11" width="9" height="9" fill="#ffb900" />
    </svg>
  );
}
